<script setup lang="ts">
import {Languages, Settings, Users, Volume2} from 'lucide-vue-next'
import {useRoute, useRouter} from 'vue-router'
import {SidebarMenu, SidebarMenuButton, SidebarMenuItem} from '@/components/ui/sidebar'
import NextCatalogNav from './NextCatalogNav.vue'
const router = useRouter()
const route = useRoute()
const emit = defineEmits<{close: []}>()
const items = [
  {key: 'translations', label: 'cp.translations', icon: Languages},
  {key: 'settings', label: 'cp.settings', icon: Settings},
  {key: 'users', label: 'cp.users', icon: Users},
  {key: 'tts-settings', label: 'cp.ttsSettings', icon: Volume2},
]
function go(key: string) {
  router.push(`/cp/${key}`)
  emit('close')
}
</script>
<template>
  <nav class="min-h-0 flex-1 overflow-y-auto p-2" aria-label="Control panel">
    <SidebarMenu>
      <SidebarMenuItem v-for="item in items" :key="item.key">
        <SidebarMenuButton
          :is-active="route.path.endsWith(item.key)"
          :tooltip="$t(item.label)"
          :data-testid="`control-panel-nav-${item.key}`"
          @click="go(item.key)">
          <component :is="item.icon" class="size-4" />
          <span>{{ $t(item.label) }}</span>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
    <NextCatalogNav @close="emit('close')" />
  </nav>
</template>
